<template>
<div>
	<div v-if="userHasNoAccess" :class="$style.no_access">
		{{ 'no_access' | str }}
	</div>
	<div v-else :class="$style.home" style="text-align: left;">
		<div :class="[$style.column, $style.side]">
			<Search v-if="searchCriteria" 
				v-on:search="subSearch"
				:language="language()" 
				:searchCriteria="searchCriteria"
				:dealerCodes="dealerCodes"
				@search="getSearchData"
				v-on:selectedDealerCode="setDealerCode"
				style="background-color: white;"
				/>
		</div>

		<div :class="[$style.column, $style.main]">
				<keep-alive>
				<ReportsView 
					v-if="view=='ReportsView'" 
					:newSearch="newSearch"
					:categories="categories" 
					:reports="reportsForCurrentLanguage" 
					:subReports="subReports" 
					:language="language()"
					v-on:subSearch="searchForReportType"
					v-on:selectTab="tabSelected"
					style="background-color: white;"
				/>
				</keep-alive>

			<transition name='fade'>
				<div v-if="view=='SubReportsView'">
					<div v-if="subReportsForCurrentLanguage.length==maxResultsPerLanguage" :class="$style.maxResults">
						{{ 'maxResults' | str }}: {{maxResultsPerLanguage}}. {{ 'toSeeMore' | str }}
					</div>
					<SubReportsView 
						:categories="categories" 
						:reports="subReportsForCurrentLanguage" 
						:totalRptNum="totalReportNumForCurrentLanguage"
						:language="language()" 
						:keyword="keywords()"
						v-on:subSearch="subSearch" 
						v-on:close="subReports=null;"
						style="background-color: white;"
					/>
				</div>
			</transition>
		</div>
	</div>
</div>
</template>

<script>

// import DealerCode from '@/components/Search/dealerCode.vue';
import Search from '@/components/Search/Search.vue';
import api from '@/lib/ServerApi';
import ReportsView from '@/components/ReportsView';
import SubReportsView from '@/components/SubReportsView'

// Dev only
// import testData from '@/data/reports_test_data'
var testData = {};


export default {
	name: 'home',
	components: {
		// DealerCode,
		ReportsView,
		SubReportsView,
		Search
	},
	mounted: function(){
		this.init();
	},
	data: function() {
		return {
			config: {
				localize: false,
				debug: {
					userType : 'admin'
				}
			},
			newSearch: false,
			reports: null,
			subReports: null,
			searchCriteria: null,
			dealerCodes: null,
			selected_dealer_code: null
		};
	},
	methods: {
		init: function(){
			// fetch the default set of reports for the user (can be empty)
			if(this.$application.isLoggedIn()){
				this.getSearchCriteria();
				this.getDefaultSet();

				var self = this;
				this.$application.initPromise.then(function() {
					if(self.$application.allowDealerCodes()) {
						self.getDealerCodes();
					}
				});
			}
		},

		// fetches the default reports for the user (only works if they are a dealer or dealerAdmin)
		getDefaultSet: function(){
			var self = this;
			if(!self.config.localize){
				api.getDefaultSet().then(response => {
					self.reports = response;
				});
			}else{
				var data = self.local();
				self.reports = data.reports;
			}
		},
		getSearchCriteria: function(){
			var self = this;
			if(!self.config.localize){
				api.getSearchCriteria().then(response => {
					self.searchCriteria = response;
				});
			}else{
				var data = self.local();
				self.searchCriteria = data.searchCriteria;
			}
		},
		getDealerCodes: function(){
			if(this.$application.allowDealerCodes()){
				if(!this.config.localize){
					api.getDealerCodes().then(response => {
						this.dealerCodes = response;
					});
				}else{
					this.dealerCodes = this.local().dealerCodes;
				}
			}else{
				this.dealerCodes = [this.$application.getDealerCode()];
			}
		},
		getSearchData: function(value){			
			this.keyword = value['keyword'];
		},
		setDealerCode: function(data){
			this.selected_dealer_code = data.selection;
		},
		mainSearchException: function(data){
			//Subsearch will look at this to determine when to use main search
			var result = this.objectLength(data)==1 && data.dealerCode!==undefined;

			return result;
		},

		// This is when the user picks a dealer code and
		// nothing else, so we should show the category view.
		searchToCategoryView: function(data){
			var self = this;
			self.subReports = null;
			self.newSearch = true;
			data = self.prepareSearchData(data);

			if(!self.config.localize){
				self.$api.getDefaultSet(data.dealerCode).then(response=>{
					self.reports = response;
				});
			}else{
				var mockData = self.local();
				self.reports = mockData.reports;
			}
		},

		// This is when the user either
		//  - selects a report to drill into more details
		//  - uses the search panel
		subSearch: function(searchParams){
			var self = this;

			var isMainSearch = this.mainSearchException(searchParams);
			var params = this.prepareSearchData(searchParams);

			if(!self.config.localize){
				//Double function for search:  Allows dealer code selection access to default report
				if(isMainSearch){
					self.searchToCategoryView(params);
				}else{
					console.log('subSearch',params);
					self.$api.search(params).then(response=>{
						self.subReports = response;
					});			
				}
			}else{
				self.subReports = self.local().reports;
			}
		},
		searchForReportType: function(searchParams) {
			var params = this.prepareSearchData(searchParams);
			// this is needed when the user clicks on an item in the summary view (ie, not click the search button)
			if(this.selected_dealer_code){
				params.dealerCode = this.selected_dealer_code;
			}

			var self = this;
			self.$api.search(params).then(response=>{
				self.subReports = response;
			});
		},
		prepareSearchData: function(data){
			var params = Object.assign({}, data);

			params.isCurrentVersion = true;

			if(this.maxResultsPerLanguage) {
				params.maxResultsPerLanguage = this.maxResultsPerLanguage;
			}
			return params;
		},
		tabSelected: function(){
			var self = this;
			setTimeout(function(){
				self.newSearch = false;
			},200);
		},
		local: function(){
			
			var searchCriteria = JSON.parse(testData.searchCriteria);
			var reports = JSON.parse(testData.reports);
			var dealerCodes = JSON.parse(testData.dealerCodes)
			var userType = JSON.parse(testData.userType);

			return {
				searchCriteria: searchCriteria,
				reports: reports,
				dealerCodes: dealerCodes,
				userType: userType
			}
		},
		language: function() {
			return this.$Localization.getLanguage();
		},
		keywords: function() {
			return this.keyword || "";
		},
		objectLength: function(obj){
			return Object.keys(obj).length;
		}
	},
	computed: {
		categories: function() {
			if(this.searchCriteria) {
				return this.language()=='fr' ? 
					this.searchCriteria.categories_fr :
					this.searchCriteria.categories;
			}
			else {
				return [];
			}
		},
		view: function(){
			var view = (this.reports===null && this.subReports===null) ?  null : this.subReports ? "SubReportsView" : "ReportsView";
			return view
		},
		reportsForCurrentLanguage: function() {
			var lang = this.language();
			return this.reports.filter(function(val){
				return val.language==lang;
			});
		},
		subReportsForCurrentLanguage: function() {
			var lang = this.language();
			var lastReport = this.subReports[this.subReports.length-1];						
			var mReports = [];
			if(lastReport.name==='TOTAL_NUM'){			
				for(let i=0; i < this.subReports.length-1; i++){
					mReports.push(this.subReports[i]);
				}
			}
			return mReports.filter(function(val){
				return val.language==lang;
			});
		},
		totalReportNumForCurrentLanguage: function() {
			var lang = this.language();
			var lastReport = this.subReports[this.subReports.length-1];
			var totalRptNumber = 0;					
			if(lastReport.name==='TOTAL_NUM'){
				if(lang=='en')
					totalRptNumber = lastReport.id;				
				else
					totalRptNumber = lastReport.reportId;	
			}
			return totalRptNumber;
		},
		userHasNoAccess: function() {
			if(this.searchCriteria!=null && this.searchCriteria.reportCodes.length==0) {
				return true;
			}
			else{
				return false;
			}
		},
		maxResultsPerLanguage: function() {
			return this.$application.getMaxSearchResultsPerLanguage();
		}
	}
}

</script>



<style module>
.home {
	padding-bottom: 20px;
}

.column{
	display: inline-block;
	vertical-align: top;
	padding: 15px;
}

.column.side{
	min-width: 200px;
	width: 25%;
	margin-top: 19px;
}

.no_access {
	margin: 80px auto;
	border: 1px solid #eee;
	max-width: 300px;
	box-shadow: -1px 1px 20px #eee;
	border-radius: 10px;
	line-height: 2em;
	padding: 50px;
}
@media only screen and (max-width: 1024px) {
	.column.side{
		width: 95%;
	}
}



.column.main{
	width: 68%;
}
@media only screen and (max-width: 1024px) {
	.column.main{
		width: 95%;
	}
}

.maxResults {
	text-align: center;
	font-size: 0.9em;
	margin: 0px auto 20px;
	color: #777;
	background: #eee;
	padding: 5px 0px;
	border-radius: 10px;
	width: 550px;
	font-weight: bold;
}
</style>